/*
 * @Author: 张玉婷
 * @Date: 2022-03-22 15:36:00
 * @LastEditTime: 2022-04-01 16:36:46
 * @LastEditors: 张玉婷
 * @Description:
 * @FilePath: \air_version_2\src\utils\cesium\pictureLayer\index.ts
 */

import * as Cesium from 'cesium';

export default class PictureLayer extends Cesium.SingleTileImageryProvider {
  timer: any;

  constructor (
    url: string,
    extent: [number, number, number, number],
    callback: any | null
  ) {
    const rectangle = Cesium.Rectangle.fromDegrees(...extent);

    super({
      url,
      rectangle,
    });

    /*
     *  资源加载失败回调
     * this.errorEvent.addEventListener(() => {
     * return callback && callback();
     * });
     */

    // 资源加载成功回调
    this.readyPromise.then(() => {
      const image: any = new Image();
      // 添加图片加载完成，且图片图层加载成功执行回调

      image.src = url;
      image.onload = (): void => callback && callback();
      image.onerror = (): void => callback && callback();
    });
  }
}
